export enum FeatureFlagId {
  Projects = "projects",
  GoogleSignIn = "google-signin",
  RegistrationInvitationOnly = "registration_invitation_only",
  RegistrationSkipPhoneConfirmation = "registration_skip_phone_confirmation",
  Deals = "deals",
}
